import { LoadReportComponent } from './load-report/load-report.component';
import { ReportComponent } from './report.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [{
  path: '',
  component: ReportComponent,
  children: [
    {
      path: ':hash',
      component: LoadReportComponent,
    },
    {
      path: '',
      component: LoadReportComponent,
    },
  ]}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportRoutingModule { }

